import { PageHeader } from '@/shared/components/PageHeader';
import { Layers } from 'lucide-react';
import JobCategoriesStep from '../components/JobCategoriesStep';

export default function JobCategoriesPage() {
  return (
    <div className="h-full flex flex-col bg-background overflow-hidden">
      <PageHeader
        title="Job Categories"
        subtitle="View and manage job category types"
        icon={<Layers className="w-7 h-7" style={{ color: '#E84A2B' }} />}
      />
      <div className="flex-1 overflow-y-auto px-6 pb-6">
        <JobCategoriesStep />
      </div>
    </div>
  );
}
